.disabledTeam {
	width: 100%;
}
